exports = module.exports = require(28);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require(30);
exports.Duplex = require(26);
exports.Transform = require(29);
exports.PassThrough = require(27);
